export default __webpack_public_path__ + "static/media/AndrewCattarin.17737e51.png";